export enum OnboardingActionStatus {
  RESUME_ONBOARDING = 'resumeOnboarding',
  PAUSE_ONBOARDING = 'pauseOnboarding',
  CANCEL_ONBOARDING = 'cancelOnboarding',
  ONBOARDING_COMPLETE = 'onboardingComplete',
}

export const PauseOnboardingModalButtonLabels: Record<
  OnboardingActionStatus,
  string
> = Object.freeze({
  [OnboardingActionStatus.RESUME_ONBOARDING]:
    'pauseOnboardingModal.pauseOnboardingModalButtonLabels.resumeOnboarding',
  [OnboardingActionStatus.PAUSE_ONBOARDING]:
    'pauseOnboardingModal.pauseOnboardingModalButtonLabels.pauseOnboarding',
  [OnboardingActionStatus.CANCEL_ONBOARDING]:
    'pauseOnboardingModal.pauseOnboardingModalButtonLabels.cancelOnboarding',
  [OnboardingActionStatus.ONBOARDING_COMPLETE]:
    'pauseOnboardingModal.pauseOnboardingModalButtonLabels.onboardingComplete',
});

export const RadioButtonOptions = Object.freeze([
  {
    value: 'MANUALLY_BOOKED_IN_EHR',
    label: 'pauseOnboardingModal.pauseOnboardingReasons.manuallyBookedInEHR',
  },
  {
    value: 'UNRESPONSIVE',
    label: 'pauseOnboardingModal.pauseOnboardingReasons.unresponsive',
  },
  {
    value: 'NOT_INTERESTED_IN_SERVICES',
    label:
      'pauseOnboardingModal.pauseOnboardingReasons.notInterestedInServices',
  },
  {
    value: 'SERVICE_NOT_COVERED_BY_INSURANCE',
    label:
      'pauseOnboardingModal.pauseOnboardingReasons.serviceNotCoveredByInsurance',
  },
  {
    value: 'NOT_APPROPRIATE_FOR_SERVICES',
    label:
      'pauseOnboardingModal.pauseOnboardingReasons.notAppropriateForServices',
  },
]);
